//ASSETS
import farma from "assets/img/map/marker.farma.svg";
import jandarm from "assets/img/map/marker.jandarm.svg";
import police from "assets/img/map/marker.police.svg";
import pomp from "assets/img/map/marker.pomp.svg";
import salva from "assets/img/map/marker.salva.svg";
import sam from "assets/img/map/marker.sam.svg";
import shelter from "assets/img/map/marker.shelter.svg";
import spital from "assets/img/map/marker.spital.svg";
import upu from "assets/img/map/marker.upu.svg";
import { default as defib } from "assets/img/map/marker.defib.svg";
import events from "assets/img/map/Orar.svg";
import pastEvents from "assets/img/map/OrarYellow.svg";

//MISC
import { SIZE } from "constants/variables";

export interface CivilShelterInfo {
  localitate?: string | null;
  proprietate_publica?: boolean | null;
  stare?: "functional" | "nefunctional" | "partial_functional" | null;
  capacitate?: number | null;
  judet_id?: { data: { id: number; attributes: { nume?: string; abreviere?: string } } | null };
}

export interface IpPoint {
  id: string;
  icon?: string;
  titlu: string;
  adresa: string;
  numar_telefon: string;
  website: string;
  latitudine: number;
  longitudine: number;
  schedule?: string;
  defibrilator?: any;
  civil_shelter?: { data: { id: number; attributes: CivilShelterInfo } | null };
}

export interface IpCategory {
  id: number;
  nume: string;
}

export interface IpCategorySet {
  [x: string]: IpPoint[];
}

export const mapper = {
  "1": { icon: jandarm, name: "constabulary" },
  "2": { icon: sam, name: "ambulance" },
  "3": { icon: pomp, name: "fire" },
  "4": { icon: salva, name: "salvamont" },
  "5": { icon: shelter, name: "shelters" },
  "6": { icon: farma, name: "pharmacies" },
  "7": { icon: spital, name: "hospitals" },
  "8": { icon: police, name: "police" },
  "9": { icon: upu, name: "emergencies" },
  "10": { icon: defib, name: "defibrilators" },
  "11": { icon: events, pastIcon: pastEvents, name: "events" },
};

export const createCustomMarkerElement = (
  icon,
  size = SIZE.max24,
  callback,
  data
) => {
  const el = document.createElement("div");
  el.className = "custom-marker";
  el.style.backgroundImage = `url(${icon})`;
  el.style.backgroundSize = "cover";
  el.style.backgroundPosition = "center";
  el.style.width = size;
  el.style.height = size;
  el.style.backgroundRepeat = "no-repeat";
  el.style.cursor = "pointer";
  el.style.touchAction = "manipulation";

  // ✅ iOS compatibility
  el.setAttribute("role", "button");
  el.setAttribute("tabindex", "0");

  el.addEventListener("pointerdown", () => callback(data));

  return el;
};

export const getBounds = (map): [number, number, number, number] => {
  const bounds = map.getBounds();

  return [
    bounds.getWest(),
    bounds.getSouth(),
    bounds.getEast(),
    bounds.getNorth(),
  ];
};
